import { Fragment, useState } from "react";

import { Tab } from "@headlessui/react";
import PropTypes from "prop-types";

import { countries } from "common/data/countries";

import { HiChevronDoubleRight } from "components/atoms/Icon/hi/HiChevronDoubleRight";
import Img from "components/atoms/Img";
import Link from "components/atoms/LinkRouter";
import TabListNew from "components/molecules/TabListNew/index";

export const MobilePricing = ({ data }) => {
  return (
    <>
      <TabListNew
        data={data.map((item) => item.place)}
        tabListClass={{
          display: "flex justify-start md:justify-center",
          border: "border-0",
          padding: "px-1 py-3",
          length: "w-full",
          othersClass: "whitespace-nowrap overflow-x-auto",
        }}
        tabClass={{
          padding: "px-6 py-2",
        }}
      >
        <Tab.Panels className="shadow-bbc mt-6 rounded-3xl bg-white py-6 px-5">
          {data.map((place, idx) => (
            <Tab.Panel
              className="focus:outline-none focus:outline-0 focus:ring-0"
              as="div"
              key={idx}
            >
              {place.countries.map((country, countryIdx) => (
                <div
                  key={countryIdx}
                  className="border-b py-5 first:pt-0 last:border-0 last:pb-0"
                >
                  <div className="flex justify-between">
                    <div className="flex">
                      <Img
                        src={`/assets/flags/1x1/${
                          countries.find((item) => item.icon === country.icon)
                            ?.icon
                        }.svg`}
                        width={24}
                        height={24}
                        className="mr-3 min-h-[24px] min-w-[24px] rounded-full"
                        alt={
                          countries.find((item) => item.icon === country.icon)
                            ?.icon
                        }
                      />
                      <Link
                        href={country.uri || ""}
                        target="_blank"
                        rel="noreferrer"
                        className="hover:text-bbc-brand-500 "
                      >
                        {country.name}
                      </Link>
                    </div>
                    {country.contact_us && (
                      <div>
                        <Link
                          href={country.contact_us || ""}
                          target="_blank"
                          rel="noreferrer"
                          className="hover:text-bbc-brand-500  "
                        >
                          Contact us for details
                        </Link>
                      </div>
                    )}
                  </div>
                  {!country.contact_us && (
                    <div className="mt-5">
                      <div className="mb-2.5 flex justify-between">
                        <span>First year fee</span>
                        <span>{country.year_fee}</span>
                      </div>
                      <div className="mb-2.5 flex justify-between">
                        <span>Annual fee *</span>
                        <span>{country.annual_fee}</span>
                      </div>
                      <div className="flex justify-between">
                        <span>Package Details</span>
                        <span>
                          <Link
                            rel="noreferrer"
                            href={country.package_details || ""}
                            target="_blank"
                            className="group hover:text-bbc-brand-500 "
                          >
                            See more
                            <HiChevronDoubleRight className="relative right-0 ml-1 inline-block transition-all duration-100 ease-in-out group-hover:-right-0.5" />
                          </Link>
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </Tab.Panel>
          ))}
        </Tab.Panels>
      </TabListNew>
      <em className="mt-6 block px-7  text-sm leading-6">
        * Annual fee does not include annual economic substance filing if there
        is any
        <br />
        ** All-inclusive Belize annual fee includes compliance fee, ES filing,
        and annual tax return filing. Please feel free to contact us for the
        pricing details.
      </em>
    </>
  );
};

const OurPricingTable = ({ data, ...props }) => {
  const renderTbody =
    data.length > 0 &&
    data.map((item, itemIdx) => {
      return (
        Array.isArray(item.countries) &&
        item.countries.length > 0 &&
        item.countries.map((tableItem, index) => {
          return (
            <tr
              key={index}
              className={`${
                itemIdx % 2 === 0 ? "bg-white" : "bg-bbc-brand-100"
              }  text-sm  leading-6 `}
            >
              {index == 0 && (
                <td
                  className={
                    "pl-7 pr-6 font-medium leading-6 text-bbc-brand-800 "
                  }
                  rowSpan={item.countries.length}
                >
                  {item.place}
                </td>
              )}
              <td className={" flex py-1.5 text-left"}>
                <Img
                  src={`/assets/flags/1x1/${
                    countries.find((item) => item.icon === tableItem.icon)?.icon
                  }.svg`}
                  width={24}
                  height={24}
                  className="mr-3 rounded-full"
                  alt={
                    countries.find((item) => item.icon === tableItem.icon)?.icon
                  }
                />
                <Link
                  rel="noreferrer"
                  href={tableItem.uri || ""}
                  target="_blank"
                  className="hover:text-bbc-brand-500 "
                >
                  {tableItem.name}
                </Link>
              </td>
              {tableItem.contact_us?.length > 0 ? (
                <td colSpan="3" className="text-center">
                  <Link
                    rel="noreferrer"
                    href={tableItem.contact_us || ""}
                    target="_blank"
                    className="hover:text-bbc-brand-500  "
                  >
                    Contact us for details
                  </Link>
                </td>
              ) : (
                <Fragment>
                  <td>{tableItem.year_fee}</td>
                  <td>{tableItem.annual_fee}</td>
                  <td>
                    <Link
                      rel="noreferrer"
                      href={tableItem.package_details || ""}
                      target="_blank"
                      className="group hover:text-bbc-brand-500 "
                    >
                      See more
                      <HiChevronDoubleRight className="relative right-0 ml-1 inline-block transition-all duration-100 ease-in-out group-hover:-right-0.5" />
                    </Link>
                  </td>
                </Fragment>
              )}
            </tr>
          );
        })
      );
    });
  const [theadArr] = useState([
    "",
    "Jurisdictions",
    "First year fee",
    "Annual fee *",
    "Package Details",
  ]);

  return (
    <div className={props.className}>
      <div className="overflow-hidden rounded-2xl border border-bbc-neutral-400 bg-white pb-[22px]">
        <table className="w-full ">
          <thead className="border-b ">
            <tr className="bg-bbc-brand-700 ">
              {theadArr.map((item, index) => (
                <th
                  key={index}
                  className={
                    "py-4 text-left text-sm font-medium leading-6 text-white"
                  }
                >
                  {item}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>{renderTbody}</tbody>
        </table>

        <em className="mt-4 block px-7  text-sm leading-6">
          * Annual fee does not include annual economic substance filing if
          there is any
          <br />
          ** All-inclusive Belize annual fee includes compliance fee, ES filing,
          and annual tax return filing. Please feel free to contact us for the
          pricing details.
        </em>
      </div>
    </div>
  );
};

export default OurPricingTable;

OurPricingTable.propTypes = {
  data: PropTypes.array,
  children: PropTypes.element,
  emi: PropTypes.bool,
};
OurPricingTable.defaultProps = {
  data: [],
  children: <></>,
};
